import styled from "@emotion/styled";
import { Skeleton } from "@kaltura/mediaspace-shared-styled";
import { useTheme } from "@mui/material";

const StyledLinks = styled("div")(({ theme }) => ({
    marginTop: theme.spacing(5),
    marginBottom: theme.spacing(2),
    display: "flex",
    justifyContent: "space-between",
    ["span"]: {
        borderRadius: theme.kaltura.shape.roundness1,
    },
}));

/**
 * global search results skeleton - gallery/channel results links
 */
export const CategoryLinksSkeleton = () => {
    const theme = useTheme();

    return (
        <>
            <StyledLinks>
                <Skeleton variant="rectangular" width={100} height={theme.spacing(3)} />
                <Skeleton variant="rectangular" width={60} height={theme.spacing(2)} />
            </StyledLinks>
        </>
    );
};
